<template>
  <v-app class="bckgrnds">
    <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-card class="form-container" style="border:1px solid">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm12 md8 style="padding-right:5px">
            <v-text-field disabled v-model="form.name" label="Student's Name"></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md4>
              <v-dialog :disabled="edit === false" ref="dialog" v-model="dateModel" persistent lazy full-width width="290px">
                              <v-text-field
                               :disabled="edit === false"
                                slot="activator"
                                v-model="form.date"
                                label="Application Date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="form.date" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="dateModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
          </v-flex>

          <v-flex xs12 sm12 md3 style="padding-right:5px">
              <v-text-field disabled v-model="form.email" label="Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px">
              <v-text-field disabled v-model="form.mobileNumber" label="Mobile Number"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3>
              <v-text-field disabled v-model="form.levelName" label="Level"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="text-align:right">
              <v-btn small flat color="primary" @click="training()">Training Details<v-icon small color="primary">keyboard_arrow_down</v-icon></v-btn>
          </v-flex>

          <v-flex xs12 sm12 md3 style="padding-right:5px" v-if="showDialog == true">
              <v-text-field disabled v-model="form.guardianName" label="Guardian Name"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px" v-if="showDialog == true">
              <v-text-field disabled type="Number" v-model="form.guardianNo" label="Guardian Number"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 style="padding-right:5px" v-if="showDialog == true">
              <v-text-field disabled v-model="form.guardianEmail" label="Guardian Email ID"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md3 v-if="showDialog == true">
              <v-text-field disabled v-model="form.relation" label="Relation"></v-text-field>
          </v-flex>

          <v-flex xs12 v-if="showDialog == true">

              <v-data-table
              :headers="headers1"
              :items="form.trainingList"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.fee }}</td>
                <td class="text-xs-left">{{ props.item.classNo }}</td>
                <td class="text-xs-left">{{ props.item.mode }}</td>
                <td class="text-xs-left">{{ props.item.fullName }}</td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 style="border:1px solid">
              <v-toolbar flat color="transparent">
                  <v-toolbar-title class="grey--text">Suggested University</v-toolbar-title>&nbsp;&nbsp;&nbsp;
                  <v-switch v-if="roleType=='Administrator'" v-model="edit" label="Want to edit ?" color="primary" hide-details></v-switch>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="800px" persistent>
                  <v-btn :disabled="edit === false" small color="primary" depressed slot="activator">Add new</v-btn>
                  <v-card style="border-radius: 10px">
                      <v-card-text>
                          <v-container grid-list-md>
                              <v-layout wrap>
                                  <v-flex xs11 sm11 md11>
                                       <v-autocomplete
                              dense
                              v-model="selectedCountry"
                              :items="country"
                              label="Select Country"
                              item-text="countryName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1 style="padding-top:25px">
                <v-icon color="green" size="25px" @click.stop="dialog1 = true">add_circle</v-icon>
                <v-dialog
      v-model="dialog1"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add Country
        </v-card-title>

        <v-card-text>
         <v-form ref="form1" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form1.countryName"
                :rules="emptyRule"
                label="Country name"
                required
              ></v-text-field>
            </v-flex>
            
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="submit1()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
                                  </v-flex>

                                  <v-flex xs11 sm11 md11>
                                       <v-autocomplete
                              dense
                              v-model="selectedUniversity"
                              :items="university"
                              label="Select University"
                              item-text="universityName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1 style="padding-top:25px">
                <v-icon color="green" size="25px" @click.stop="dialog2 = true">add_circle</v-icon>
                <v-dialog
      v-model="dialog2"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add University
        </v-card-title>

        <v-card-text>
         <v-form ref="form2" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form2.universityName"
                :rules="emptyRule"
                label="University name"
                required
              ></v-text-field>
            </v-flex>
            
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="submit2()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
                                  </v-flex>

                                  <v-flex xs11 sm11 md11>
                                       <v-autocomplete
                              dense
                              v-model="selectedCourse"
                              :items="course"
                              label="Select Course"
                              item-text="courseName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                              ></v-autocomplete>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1 style="padding-top:25px">
                <v-icon color="green" size="25px" @click.stop="dialog3 = true">add_circle</v-icon>
                <v-dialog
      v-model="dialog3"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add Course
        </v-card-title>

        <v-card-text>
         <v-form ref="form3" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="form3.courseName"
                :rules="emptyRule"
                label="Course name"
                required
              ></v-text-field>
            </v-flex>
            
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="submit3()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
                                  </v-flex>
                                  <v-flex xs12>
                                 <v-textarea
                                 :auto-grow="true" 
                                 rows="3" row-height="10" 
                                 v-model="editedItem.remarks"
                                 label="Remarks"
                                 ></v-textarea>
                                </v-flex>

                                <v-flex xs12>
              <b-form-checkbox
               v-model="editedItem.confirm"
            >
               Confirm
            </b-form-checkbox>
          </v-flex>
                              </v-layout>
                          </v-container>
                      </v-card-text>
                      <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" flat @click="close()">Cancel</v-btn>
                    <v-btn color="success" flat @click="save()">Save</v-btn>
                  </v-card-actions>
                  </v-card>
              </v-dialog>
              </v-toolbar>

              <v-data-table
              :headers="headers"
              :items="itemAdded"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.countryName }}</td>
                <td class="text-xs-left">{{ props.item.universityName }}</td>
                <td class="text-xs-left">{{ props.item.courseName }}</td>
                <td class="text-xs-left">{{ props.item.remarks }}</td>
                <td class="text-xs-left" style="cursor:pointer">
                    <v-icon :disabled="edit === false" v-if="props.item.confirm == true" small color="primary" @click="onConfirm(props.item)">check_circle</v-icon>
                    <v-icon :disabled="edit === false" v-if="props.item.confirm == false" small color="primary" @click="onConfirm(props.item)">panorama_fish_eye</v-icon>
                </td>
                <td class="justify-center">
                  <v-icon :disabled="edit === false" color="error" class="ml-2" small @click="deleteItem(props.item)">delete</v-icon>
                </td>
              </template>
            </v-data-table>

            <div style="text-align:right">
                <v-btn :disabled="edit === false" small v-if="itemAdded.length > 0" depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
            <v-btn :disabled="edit === false" small depressed color="orange" dark @click="back()">Cancel</v-btn>
            </div>
          </v-flex>


          <v-flex xs12 style="border:1px solid;margin-top:25px">
              <v-toolbar flat color="transparent">
                  <v-toolbar-title class="grey--text">Final Application</v-toolbar-title>
              </v-toolbar>
              <v-data-table
              :headers="headers2"
              :items="form.finalApplication"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left" style="cursor:pointer">
                    <v-icon v-if="props.item.finalConfirm == true" small color="primary" @click="onConfirm1(props.item)">check_circle</v-icon>
                    <v-icon v-if="props.item.finalConfirm == false" small color="primary" @click="onConfirm1(props.item)">panorama_fish_eye</v-icon>
                </td>
                <td class="text-xs-left">{{ props.item.countryName }}</td>
                <td class="text-xs-left">{{ props.item.universityName }}</td>
                <td class="text-xs-left">{{ props.item.courseName }}</td>
                <td class="text-xs-left">{{ props.item.remarks }}</td>
                <td class="justify-center">
                  <v-icon color="primary" class="ml-2" small @click="onEdit(props.item)">edit</v-icon>
                </td>
              </template>
            </v-data-table>


            <v-dialog width="700px" v-model="finalDialog">
                <v-card flat>
                    <v-container style="border:1px solid">
                        <v-layout wrap row style="margin:15px;padding:10px;border:1px solid">
                            <h5 style="text-align:center">Student Name :&nbsp;{{form.name}}</h5>
                            <v-flex xs12>
                                <v-text-field v-model="final.applicationThrough" label="Application through" ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="final.applicationFee" label="Application fee" ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete
              v-model="selectedSubmission"
              :items="submission"
              color="primary"
              label="Submission"
              item-text="submission"
              item-value="submission"
            ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete
              v-model="selectedSubStatus"
              :items="subStatus"
              color="primary"
              label="Submission Status"
              item-text="status"
              item-value="status"
            ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete
              v-model="selectedOffer"
              :items="offer"
              color="primary"
              label="Offer Status"
              item-text="status"
              item-value="status"
            ></v-autocomplete>
                            </v-flex>
                            
                        </v-layout>
                        <div style="text-align:right">
                                <v-btn small depressed :loading="btnSave" color="primary" dark @click="onSubmit1(final)">Save </v-btn>
                                <v-btn small depressed color="orange" dark @click="cancel()">Cancel</v-btn>
                            </div>
                    </v-container>
                </v-card>
            </v-dialog>
          </v-flex>


          <v-flex xs12 style="border:1px solid;margin-top:25px">
              <v-toolbar flat color="transparent">
                  <v-toolbar-title class="grey--text">Admission & Deposit</v-toolbar-title>
              </v-toolbar>
              <v-data-table
              :headers="headers3"
              :items="form.deposit"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.countryName }}</td>
                <td class="text-xs-left">{{ props.item.universityName }}</td>
                <td class="text-xs-left">{{ props.item.courseName }}</td>
                <td class="text-xs-left">{{ props.item.admissionDate }}</td>
                <td class="text-xs-left">{{ props.item.admissionAmount }}</td>
                <td class="justify-center">
                  <v-icon color="primary" class="ml-2" small @click="onEdit1(props.item)">edit</v-icon>
                </td>
              </template>
            </v-data-table>


            <v-dialog width="850px" v-model="finalDialog1">
                <v-card flat>
                    <v-container style="border:1px solid">
                        <v-layout wrap row style="margin:15px;padding:10px;border:1px solid">
                            <h5 style="text-align:center">Student Name :&nbsp;{{form.name}}</h5>
                            <v-flex xs12>
                                <v-dialog ref="dialog" v-model="admissionModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="deposit.admissionDate"
                                label="Admission Date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="deposit.admissionDate" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="admissionModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="deposit.admissionAmount" label="Admission Amount" ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="deposit.masterAgent" label="Master Agent" ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-dialog ref="dialog" v-model="deadlineModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="deposit.deadline"
                                label="Deadline"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="deposit.deadline" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="deadlineModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
                            </v-flex>
                            <v-flex xs12 style="text-align:right">
                                <v-btn small depressed :loading="btnSave" color="primary" dark @click="onSubmit2(deposit)">Save </v-btn>
                                <v-btn small depressed color="orange" dark @click="cancel1()">Cancel</v-btn>
                            </v-flex>
                        </v-layout>
                        
                        <v-layout row wrap style="margin:15px;padding:10px;border:1px solid">
                          <v-flex xs12 sm12 md6>
                            <h5>Payment</h5>
                          </v-flex>
                          <v-flex xs12 sm12 md6 style="text-align:right">
                             <v-btn small depressed color="grey" dark @click="addPay()">Add Payment</v-btn>
                          </v-flex>
                          <v-flex xs12>
                            <v-data-table
              :headers="headers4"
              :items="deposit.payment"
              :disable-initial-sort="true"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.index + 1 }}</td>
                <td class="text-xs-left">{{ props.item.gateway }}</td>
                <td class="text-xs-left">{{ props.item.payAmount }}</td>
                <td class="text-xs-left">{{ props.item.nextDate }}</td>
                <td class="text-xs-left">{{ props.item.dueAmount }}</td>
              </template>
            </v-data-table>
                          </v-flex>

                          <v-dialog width="850px" v-model="payDialog">
                             <v-card flat>
                               <v-container style="border:1px solid">
                                 <v-layout wrap row style="margin:15px;padding:10px;border:1px solid">
                                   <v-flex xs12>
                                <v-text-field v-model="pay.gateway" label="Payment Gateway" ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="pay.payAmount" label="Paid Amount" ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-dialog ref="dialog" v-model="nextModel" persistent lazy full-width width="290px">
                              <v-text-field
                                slot="activator"
                                v-model="pay.nextDate"
                                label="Next payment date"
                                append-icon="event"
                                readonly
                              ></v-text-field>
                              <v-date-picker v-model="pay.nextDate" scrollable>
                               <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="nextModel = false">ok</v-btn>
                             </v-date-picker>
                            </v-dialog>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="pay.dueAmount" label="Due Amount" ></v-text-field>
                            </v-flex>
                            <v-flex xs12 style="text-align:right">
                                <v-btn small depressed :loading="btnSave" color="primary" dark @click="onSubmit3(deposit)">Save </v-btn>
                                <v-btn small depressed color="orange" dark @click="cancel2()">Cancel</v-btn>
                            </v-flex>
                                 </v-layout>
                               </v-container>
                             </v-card>
                          </v-dialog>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      entries: [],
      isLoading: false,
      showDialog: false,
      finalDialog: false,
      finalDialog1: false,
      payDialog: false,
      admissionModel: false,
      deadlineModel: false,
      nextModel: false,
      edit: false,
      model: null,
      search: null,
      btnSave: false,
      dialog: false,
      dateModel: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,

      itemAdded: [],

      editedItem: {
          remarks: null,
          confirm: false
      },

      pay: {
        gateway: null,
        payAmount: null,
        nxtDate: null,
        dueAmount: null
      },


      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
      },

      headers: [
        { text: "#", value: "#" },
        { text: "Country", value: "countryName" },
        { text: "Universty", value: "universityName" },
        { text: "Course", value: "courseName" },
        { text: "Remarks", value: "remarks" },
        { text: "Confirm", value: "confirm" },
        { text: "Action", value: "action" }
      ],

      headers2: [
        { text: "#", value: "#" },
        { text: "Confirm", value: "confirm" },
        { text: "Country", value: "countryName" },
        { text: "Universty", value: "universityName" },
        { text: "Course", value: "courseName" },
        { text: "Remarks", value: "remarks" },
        { text: "Action", value: "action" }
      ],

      headers3: [
        { text: "#", value: "#" },
        { text: "Country", value: "countryName" },
        { text: "Universty", value: "universityName" },
        { text: "Course", value: "courseName" },
        { text: "Admission Date", value: "admissionDate" },
        { text: "Admission Amount", value: "admissionAmount" },
        { text: "Action", value: "action" }
      ],
      headers4: [
        { text: "#", value: "#" },
        { text: "Payment Gateway", value: "gateway" },
        { text: "Paid Amount", value: "payAmount" },
        { text: "Next Date", value: "nextDate" },
        { text: "Due Amount", value: "dueAmount" }
      ],

      valid: true,
      roleType: sessionStorage.roles,

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Application",
          disabled: false,
          to: "/application"
        },
        {
          text: "Edit",
          disabled: true,
          to: "/createLead"
        }
      ],

      country: null,
      selectedCountry: null,

      university: null,
      selectedUniversity: null,

      course: null,
      selectedCourse: null,

      lead: null,
      selectedLead: null,

      date1: new Date(),

      form: {
        date: new Date().toISOString().substr(0, 10)
      },

      form1: {
        countryName: null
      },
      form2: {
        universityName: null
      },
      form3: {
        courseName: null
      },
      form4: {
        levelName: null
      },

      final: {},
      deposit: {},

      headers1: [
        { text: "#", value: "#" },
        { text: "Training Type", value: "name" },
        { text: "Fee", value: "fee" },
        { text: "No. of Class", value: "classNo" },
        { text: "Mode", value: "mode" },
        { text: "Teacher", value: "fullName" }
      ],

      submission: ["Yes", "No"],
      selectedSubmission: null,

      subStatus: [],
      selectedSubStatus: null,

      offer: [],
      selectedOffer: null,
    };
  },

  mounted() {
      this.getData1();
      this.getData2();
      this.getData3();
      this.getData4();
      this.getLead();
      this.getData();
      this.getDataSub();
      this.getDataOffer();
    },

  methods: {
      getData() {
      this.axios
      .get(config.API + `Applications/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        this.itemAdded = res.data.applicationDetails;
      });
    },
    getDataSub() {
      this.axios
      .get(config.API + `SubmissionStatus`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.subStatus = res.data;
      });
    },
    getDataOffer() {
      this.axios
      .get(config.API + `OfferStatus`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.offer = res.data;
      });
    },
      getLead() {
        this.axios
        .get(config.API + "LeadSelection1", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.lead = res.data;
          this.$Progress.finish();
          this.getLead();
        });
    },
    getData1() {
      this.axios
        .get(config.API + "Countries", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.country = res.data;
          this.getData1();
        });
    },
    
    getData2() {
      this.axios
        .get(config.API + "Universities", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.university = res.data;
          this.getData2();
        });
    },
        
    getData3() {
      this.axios
        .get(config.API + "Courses", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.course = res.data;
          this.getData3();
        });
    },

    getData4() {
      this.axios
        .get(config.API + "Levels", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.level = res.data;
          this.getData4();
        });
    },
        
    submit1() {
    if (this.$refs.form1.validate()) {
      this.axios
          .post(
            config.API + "Countries",
            {
              countryName: this.form1.countryName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Country successfully added");
            this.form1.countryName = null;
            this.dialog1 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit2() {
    if (this.$refs.form2.validate()) {
      this.axios
          .post(
            config.API + "Universities",
            {
              universityName: this.form2.universityName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("University successfully added");
            this.form2.universityName = null;
            this.dialog2 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit3() {
    if (this.$refs.form3.validate()) {
      this.axios
          .post(
            config.API + "Courses",
            {
              courseName: this.form3.courseName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Course successfully added");
            this.form3.courseName = null;
            this.dialog3 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    submit4() {
    if (this.$refs.form4.validate()) {
      this.axios
          .post(
            config.API + "Levels",
            {
              levelName: this.form4.levelName
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log("Success");
            this.$toaster.success("Level successfully added");
            this.form4.levelName = null;
            this.dialog4 = false;
          })
          .catch(err => {
            console.log(err.message);
          });
    }
    },

    training() {
        if(this.showDialog == false) {
            this.showDialog = true;
        }
        else {
            this.showDialog = false;
        }
    },

    back() {
      this.$router.go(-1);
    },
    cancel() {
      this.finalDialog = false;
    },
    cancel1() {
      this.finalDialog1 = false;
    },
    cancel2() {
      this.payDialog = false;
    },

    addPay() {
      this.finalDialog1 = false;
      this.payDialog = true;
    },
    
    onEdit(item) {
        this.finalDialog = true;
        this.final = item;
        this.selectedSubmission = item.submission;
        this.selectedSubStatus = item.submissionStatus;
        this.selectedOffer = item.offerStatus;
        console.log(item);
    },
    onEdit1(item) {
        this.finalDialog1 = true;
        this.deposit = item;
        console.log(item);
    },

    onConfirm(item) {
        console.log(item);
      if(confirm("Do you want to change this ?")) {
          if(item.confirm == true) {
              this.axios
          .put(
            config.API + `ApplicationDetails/${item.ids}`,
            {
              id: JSON.parse(item.ids),
              confirm: false
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
          }
          else {
              this.axios
          .put(
            config.API + `ApplicationDetails/${item.ids}`,
            {
              id: JSON.parse(item.ids),
              confirm: true
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
          }
      }
    },

    onConfirm1(item) {
        console.log(item);
      if(confirm("Do you want to change this ?")) {
          if(item.finalConfirm == true) {
              this.axios
          .put(
            config.API + `ApplicationDetails2/${item.ids}`,
            {
              id: JSON.parse(item.ids),
              finalConfirm: false
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
          }
          else {
              this.axios
          .put(
            config.API + `ApplicationDetails2/${item.ids}`,
            {
              id: JSON.parse(item.ids),
              finalConfirm: true
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
          }
      }
    },

    onSubmit1(final) {
        console.log(final);
        this.btnSave = true;
        this.axios
          .put(
            config.API + `ApplicationDetails1/${final.ids}`,
            {
              id: JSON.parse(final.ids),
              applicationThrough: this.final.applicationThrough,
              applicationFee: this.final.applicationFee,
              submission: this.selectedSubmission,
              submissionStatus: this.selectedSubStatus,
              offerStatus: this.selectedOffer
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.btnSave = false;
            this.finalDialog = false;
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
    },

    onSubmit2(deposit) {
        console.log(deposit);
        this.btnSave = true;
        this.axios
          .put(
            config.API + `ApplicationDetails3/${deposit.ids}`,
            {
              id: JSON.parse(deposit.ids),
              admissionDate: deposit.admissionDate,
              admissionAmount: deposit.admissionAmount,
              masterAgent: deposit.masterAgent,
              deadline: deposit.deadline
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.btnSave = false;
            this.finalDialog1 = false;
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
    },

    onSubmit3() {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `ApplicationPayments`,
            {
              applicationId: JSON.parse(this.deposit.ids),
              gateway: this.pay.gateway,
              payAmount: this.pay.payAmount,
              nextDate: this.pay.nextDate,
              dueAmount: this.pay.dueAmount
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            this.btnSave = false;
            this.payDialog = false;
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
    },

    close() {
      this.dialog = false;
      this.selectedCountry = null;
      this.selectedUniversity = null;
      this.selectedCourse = null;
    },

      deleteItem(item) {
      if(confirm("Are you sure you want to delete this selection?")) {
        const index = this.itemAdded.indexOf(item);
        this.itemAdded.splice(index, 1);
          this.axios
          .delete(config.API + `ApplicationDetails/${item.ids}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            console.log('OK');
          })
      }
    },

    save() {
        if(this.selectedCountry != null && this.selectedUniversity != null && this.selectedCourse != null) {
            let lth = this.itemAdded.length;
            if (lth == 0) {
              this.itemAdded.push({
               countryId: JSON.parse(this.selectedCountry.id),
               universityId: JSON.parse(this.selectedUniversity.id),
               courseId: JSON.parse(this.selectedCourse.id),
               countryName: this.selectedCountry.countryName,
               universityName: this.selectedUniversity.universityName,
               courseName: this.selectedCourse.courseName,
               remarks: this.editedItem.remarks,
               confirm: this.editedItem.confirm
              });

              this.close();
            }
            else {
                let flag = false;

                for(let i = 0; i < lth; i++) {
                    let _countryId = this.itemAdded[i].countryId;
                    let _universityId = this.itemAdded[i].universityId;
                    let _courseId = this.itemAdded[i].courseId;

                    if(_countryId == this.selectedCountry.id && _universityId == this.selectedUniversity.id && _courseId == this.selectedCourse.id) {
                        flag = true;
                    }
                }

                if (flag == true) {
                this.$toaster.error(`Already Taken!!`);
               }
               else {
                   this.itemAdded.push({
               countryId: JSON.parse(this.selectedCountry.id),
               universityId: JSON.parse(this.selectedUniversity.id),
               courseId: JSON.parse(this.selectedCourse.id),
               countryName: this.selectedCountry.countryName,
               universityName: this.selectedUniversity.universityName,
               courseName: this.selectedCourse.courseName,
               remarks: this.editedItem.remarks,
               confirm: this.editedItem.confirm
              });

              this.close();
               }
            }
        }
        else {
            this.$toaster.error(`Please select one!!`);
        }
        
      },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Applications/${this.form.id}`,
            {
              id: JSON.parse(this.form.id),
              date: new Date(this.form.date),

              applicationDetails: this.itemAdded
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.getData();
            this.btnSave = false;
          })
          .catch(err => {
            this.$toaster.error(`Something goes wrong`);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  }
};
</script>

<style>
.bckgrnds {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
</style>
